import { render, staticRenderFns } from "./ReportWinLose.vue?vue&type=template&id=bee87b52&scoped=true"
import script from "./ReportWinLose.vue?vue&type=script&lang=js"
export * from "./ReportWinLose.vue?vue&type=script&lang=js"
import style0 from "./ReportWinLose.vue?vue&type=style&index=0&id=bee87b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee87b52",
  null
  
)

export default component.exports